function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Port of https://github.com/react-bootstrap/react-bootstrap/blob/master/src/Collapse.js
import React, { Component } from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { jsx as _jsx } from "react/jsx-runtime";
class Collapse extends Component {
  static getHeight(elem) {
    var scrollBarWidth = elem.scrollWidth - elem.clientWidth;
    return elem.scrollHeight - scrollBarWidth;
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "nodeRef", /*#__PURE__*/React.createRef());
    this.handleEntered = this.handleEntered.bind(this);
  }
  handleEntered() {
    var elem = this.nodeRef.current;
    if (!elem) {
      return;
    }
    elem.style.height = '';
    var autoFocusOnShow = this.props.autoFocusOnShow;
    if (autoFocusOnShow !== undefined && autoFocusOnShow) {
      var input = elem.querySelector('input, select, textarea');
      if (input != null) {
        input.focus();
      }
    }
  }
  handleEnter() {
    var elem = this.nodeRef.current;
    if (!elem) {
      return;
    }
    elem.style.height = '0';
  }
  handleEntering() {
    var elem = this.nodeRef.current;
    if (!elem) {
      return;
    }
    elem.style.height = "".concat(Collapse.getHeight(elem), "px");
  }
  handleExiting() {
    var elem = this.nodeRef.current;
    if (!elem) {
      return;
    }
    elem.style.height = '0';
  }
  handleExit() {
    var elem = this.nodeRef.current;
    if (!elem) {
      return;
    }
    elem.style.height = "".concat(Collapse.getHeight(elem), "px");
  }
  render() {
    var _this$props = this.props,
      _children = _this$props.children,
      className = _this$props.className,
      inTransition = _this$props.in,
      dataTestId = _this$props['data-testid'];
    return /*#__PURE__*/_jsx(CSSTransition, {
      in: inTransition,
      classNames: {
        enterActive: 'collapsing',
        enterDone: 'collapse show',
        exitActive: 'collapsing',
        exitDone: 'collapse'
      },
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered,
      onExit: this.handleExit,
      onExiting: this.handleExiting,
      timeout: 350,
      nodeRef: this.nodeRef,
      children: state => /*#__PURE__*/_jsx("div", {
        ref: this.nodeRef,
        className: classNames({
          collapse: state === 'exited'
        }, className),
        "data-testid": dataTestId,
        children: _children
      })
    });
  }
}
_defineProperty(Collapse, "defaultProps", {
  className: '',
  autoFocusOnShow: false,
  'data-testid': undefined
});
export default Collapse;
//# sourceMappingURL=Collapse.js.map